const PATH = 'app/signUp';

export const SEND_SURVEY_LOADING = `${PATH}SEND_SURVEY_LOADING`;
export const SEND_SURVEY_REQUEST = `${PATH}SEND_SURVEY_REQUEST`;
export const SEND_SURVEY_SUCCESS = `${PATH}SEND_SURVEY_SUCCESS`;
export const SEND_SURVEY_ERROR = `${PATH}SEND_SURVEY_ERROR`;